import React from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { IconButton, Typography, Box } from "@mui/material";
import "../../styles/navbar/Topbar.css";

export const Topbar = (props) => {
  return (
    <div className="Topbar">
      <IconButton
        onClick={() => {
          props.showSidebar();
        }}
        sx={{ color: "#1a1d23" }}
      >
        <MenuIcon />
      </IconButton>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box
          sx={{
            width: 28,
            height: 28,
            borderRadius: "7px",
            background: "#8a1125",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              color: "white",
              fontFamily: '"Outfit", sans-serif',
              fontWeight: 700,
              fontSize: "13px",
            }}
          >
            V
          </Typography>
        </Box>
        <Typography
          sx={{
            color: "#5f6877",
            fontSize: "14px",
            fontWeight: 500,
          }}
        >
          Varna Admin
        </Typography>
      </Box>
    </div>
  );
};
